// Modules
import { useCallback, useState } from "react";
import { useRouter } from "next/router";

// Constants
import { QueryStringPrimaryKeys } from "constants/urlEnum";

// Utils
import { appendQueryStringParameterInUrl, changeParameterInQueryString, existFilterInQueryString, removeParameterFromUrl } from "utils/queryString";

// Redux
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { numberElementsPerPageSelector, setNumberPerPage} from "redux/filters/filtersSlice";

// Hooks
import useRouting from "hooks/useRouting";

interface SectionContentUtilsProps {
	totalNumberOfCourses: number;
}

const SectionContentUtils = ({ totalNumberOfCourses }: SectionContentUtilsProps): JSX.Element => {
	const dispatch = useAppDispatch();
	const numberElements = useAppSelector(numberElementsPerPageSelector);
	const [showNumberPerPageList, setShowNumberPerPageList] = useState(false);

	const router = useRouter();
	const pushNewRoute = useRouting();

	const checkResultQuery = useCallback(() => {
		return router.query[QueryStringPrimaryKeys.SEARCH] || "corsi";
	}, [router]);

	const onSelectNumberPerPage = (numberPerPage: number) => {
		dispatch(setNumberPerPage(numberPerPage));
		const urlPathWithoutPagination = removeParameterFromUrl(router.asPath.split("/formazione/")[1], QueryStringPrimaryKeys.PAGE);
		if (existFilterInQueryString(QueryStringPrimaryKeys.SHOW_NUMBER_PRODUCTS, router.asPath).length) {
			pushNewRoute(changeParameterInQueryString(urlPathWithoutPagination, QueryStringPrimaryKeys.SHOW_NUMBER_PRODUCTS, numberPerPage));
		} else {
			pushNewRoute(
				appendQueryStringParameterInUrl(router.query, { queryStringKey: QueryStringPrimaryKeys.SHOW_NUMBER_PRODUCTS, queryStringValue: numberPerPage.toString() }, true)
			);
		}

		setShowNumberPerPageList(false);
	};

	return (
		<>
			<div className="section-content__utils">
				<div className="result-info">
					<span className="reresult-info__no">{totalNumberOfCourses}</span> corsi visualizzati: <span className="reresult-info__desc">{checkResultQuery()}</span>
				</div>
				<div className="limiter">
					<label htmlFor="PRODUCT_LIMITER">Mostra:</label>
					<div className="selectricWrapper selectric-limiterSelect">
						<div className="selectric">
							<span className="label">{numberElements}</span>
							<button type="button" className="button" onClick={() => setShowNumberPerPageList(!showNumberPerPageList)} />
						</div>
						<div className="selectricItems" tabIndex={-1} style={{ display: showNumberPerPageList ? "block" : "none" }}>
							<div className="selectricScroll">
								<ul>
									<li data-index="0" className={numberElements === 12 ? "selected" : ""} onClick={() => onSelectNumberPerPage(12)}>
										12
									</li>
									<li data-index="1" className={numberElements === 15 ? "selected" : ""} onClick={() => onSelectNumberPerPage(15)}>
										15
									</li>
									<li data-index="2" className={numberElements === 18 ? "selected last" : "last"} onClick={() => onSelectNumberPerPage(18)}>
										18
									</li>
								</ul>
							</div>
						</div>
						<input className="selectricInput" tabIndex={0} />
					</div>
				</div>
			</div>
		</>
	);
};

export default SectionContentUtils;
